import { Address } from '~domains/partner-application/entities/application';

import { InfoCard } from '~shared/ui/info-card';

import { AddressReviewItems } from './address-review-items';

type RegisteredAddressReviewProps = {
  registeredAddress: Address | undefined;
  onEdit?: () => void;
};

export const RegisteredAddressReview = ({
  registeredAddress,
  onEdit,
}: RegisteredAddressReviewProps) => {
  if (!registeredAddress) {
    return null;
  }

  return (
    <InfoCard header="Registered business address" onEdit={onEdit}>
      <div className="grid grid-cols-2 gap-4">
        <AddressReviewItems address={registeredAddress} />
      </div>
    </InfoCard>
  );
};
